import React from 'react';
import { IconProps } from '.';

const SvgLoadingDots = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 3.75)) || 8}
      x={10}
      y={10}
      viewBox='0 0 40 8'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <circle cx={4.8} cy={4} r={4.8} fill={color}>
        <animate attributeName='opacity' begin={0.1} dur='1s' repeatCount='indefinite' values='0;1;0' />
      </circle>
      <circle cx={20} cy={4} r={4.8} fill={color}>
        <animate attributeName='opacity' begin={0.2} dur='1s' repeatCount='indefinite' values='0;1;0' />
      </circle>
      <circle cx={35.2} cy={4} r={4.8} fill={color}>
        <animate attributeName='opacity' begin={0.3} dur='1s' repeatCount='indefinite' values='0;1;0' />
      </circle>
    </svg>
  );
};

export default SvgLoadingDots;
